// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Bridge__ButtonController from "./bridge/button_controller"
application.register("bridge--button", Bridge__ButtonController)

import Bridge__PushTokenController from "./bridge/push_token_controller"
application.register("bridge--push-token", Bridge__PushTokenController)

import Bridge__SignInWithOauthController from "./bridge/sign_in_with_oauth_controller"
application.register("bridge--sign-in-with-oauth", Bridge__SignInWithOauthController)

import DatePresetController from "./date_preset_controller"
application.register("date-preset", DatePresetController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import LocationSelectController from "./location_select_controller"
application.register("location-select", LocationSelectController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import WebPushController from "./web_push_controller"
application.register("web-push", WebPushController)
